/**
 * Painta Professional Brushes Landing Page
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroVideos() {
    document.querySelectorAll('[data-painta-hero] video').forEach((video) => {
      if (REDUCED) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }
      video.muted = true;
      video.playsInline = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });
  }

  function initBrushParade(root) {
    const tabs = [...root.querySelectorAll('[data-painta-tab]')];
    const brushes = [...root.querySelectorAll('[data-painta-brush]')];
    const rail = root.querySelector('[data-painta-rail]');
    const info = root.querySelector('[data-painta-info]');
    if (!brushes.length || !info) return;

    const fields = {
      set: info.querySelector('[data-info-set]'),
      exclusive: info.querySelector('[data-info-exclusive]'),
      size: info.querySelector('[data-info-size]'),
      name: info.querySelector('[data-info-name]'),
      use: info.querySelector('[data-info-use]'),
      ideal: info.querySelector('[data-info-ideal]'),
      buy: info.querySelector('[data-info-buy]'),
      empty: info.querySelector('[data-info-empty]'),
      content: info.querySelector('[data-info-content]'),
    };

    let activeSet = root.dataset.defaultSet || 'basic';
    let activeBrush = null;
    let idleBrush = null;

    function visibleBrushes() {
      return brushes.filter((b) => b.dataset.setKey === activeSet);
    }

    function clearIdle() {
      if (idleBrush) {
        idleBrush.classList.remove('is-idle-hint');
        idleBrush = null;
      }
    }

    function setIdleHint() {
      clearIdle();
      if (REDUCED || root.dataset.idleHint !== 'true') return;
      const first = visibleBrushes()[0];
      if (!first || activeBrush) return;
      idleBrush = first;
      idleBrush.classList.add('is-idle-hint');
    }

    function renderInfo(brush) {
      if (!brush) {
        if (fields.content) fields.content.hidden = true;
        if (fields.empty) fields.empty.hidden = false;
        return;
      }
      if (fields.content) fields.content.hidden = false;
      if (fields.empty) fields.empty.hidden = true;
      if (fields.set) fields.set.textContent = brush.dataset.setLabel || '';
      if (fields.exclusive) {
        const exclusive = brush.dataset.exclusive || '';
        fields.exclusive.textContent = exclusive;
        fields.exclusive.hidden = !exclusive;
      }
      if (fields.size) fields.size.textContent = brush.dataset.sizeLabel || '';
      if (fields.name) fields.name.textContent = brush.dataset.name || '';
      if (fields.use) fields.use.textContent = brush.dataset.useCase || '';
      if (fields.ideal) {
        const ideal = brush.dataset.idealFor || '';
        fields.ideal.innerHTML = ideal
          ? `<strong>Ideal für:</strong> ${ideal}`
          : '';
        fields.ideal.hidden = !ideal;
      }
      if (fields.buy) {
        const url = brush.dataset.productUrl || '';
        if (url) {
          fields.buy.href = url;
          fields.buy.hidden = false;
        } else {
          fields.buy.hidden = true;
          fields.buy.removeAttribute('href');
        }
      }
    }

    function activateBrush(brush, { sticky = true } = {}) {
      if (!brush || brush.hidden) return;
      clearIdle();
      brushes.forEach((b) => b.classList.toggle('is-active', b === brush));
      if (rail) rail.classList.add('is-engaged');
      activeBrush = sticky ? brush : activeBrush;
      renderInfo(brush);
      brush.setAttribute('aria-pressed', 'true');
      brushes.forEach((b) => {
        if (b !== brush) b.setAttribute('aria-pressed', 'false');
      });
    }

    function filterSet(setKey) {
      activeSet = setKey;
      activeBrush = null;
      brushes.forEach((b) => {
        const match = b.dataset.setKey === setKey;
        b.hidden = !match;
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      tabs.forEach((tab) => {
        const on = tab.dataset.paintaTab === setKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (rail) rail.classList.remove('is-engaged');
      renderInfo(null);
      const first = visibleBrushes()[0];
      if (first) activateBrush(first);
      else setIdleHint();
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => filterSet(tab.dataset.paintaTab));
    });

    brushes.forEach((brush) => {
      brush.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          activateBrush(brush, { sticky: false });
          activeBrush = brush;
        }
      });
      brush.addEventListener('focus', () => activateBrush(brush));
      brush.addEventListener('click', () => activateBrush(brush));
    });

    // Deep link: ?set= / #pinsel-basic / #pinsel-detail
    const params = new URLSearchParams(window.location.search);
    const setFromUrl = params.get('set');
    if (setFromUrl === 'basic' || setFromUrl === 'detail') {
      activeSet = setFromUrl;
    }
    if (window.location.hash === '#pinsel-detail') activeSet = 'detail';
    if (window.location.hash === '#pinsel-basic') activeSet = 'basic';

    filterSet(activeSet);
  }

  function resolvePaintaTarget(hash) {
    if (!hash || hash === '#') return null;
    if (hash === '#pinsel-basic' || hash === '#pinsel-detail' || hash === '#pinsel') {
      const parade = document.querySelector('[data-painta-parade]');
      if (!parade) return null;
      return {
        el: parade,
        setKey: hash === '#pinsel-detail' ? 'detail' : hash === '#pinsel-basic' ? 'basic' : null,
      };
    }
    const el = document.querySelector(hash);
    return el ? { el, setKey: null } : null;
  }

  function goToPaintaTarget(hash, { updateHash = true } = {}) {
    const target = resolvePaintaTarget(hash);
    if (!target) return false;
    target.el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    if (target.setKey) {
      const tab = target.el.querySelector(`[data-painta-tab="${target.setKey}"]`);
      if (tab) tab.click();
    }
    if (updateHash && hash) {
      history.replaceState(null, '', hash);
    }
    return true;
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        if (!resolvePaintaTarget(id)) return;
        e.preventDefault();
        goToPaintaTarget(id);
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-painta-faq-q]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.painta-faq__item');
        const answer = item && item.querySelector('[data-painta-faq-a]');
        if (!answer) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-painta-faq-q]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = other.closest('.painta-faq__item')?.querySelector('[data-painta-faq-a]');
          if (otherAnswer) otherAnswer.hidden = true;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  function initSimulator(root) {
    const canvas = root.querySelector('[data-sim-canvas]');
    const hint = root.querySelector('[data-sim-canvas-hint]');
    const status = root.querySelector('[data-sim-status]');
    const clearBtn = root.querySelector('[data-sim-clear]');
    const setTabs = [...root.querySelectorAll('[data-sim-set]')];
    const brushes = [...root.querySelectorAll('[data-sim-brush]')];
    const colors = [...root.querySelectorAll('[data-sim-color]')];
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let drawing = false;
    let lastX = 0;
    let lastY = 0;
    let activeSet = 'basic';
    let strokeWidth = 2;
    let strokeColor = '#101820';
    let hasDrawn = false;

    function resizeCanvas() {
      const stage = canvas.parentElement;
      const rect = stage.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = Math.max(1, Math.floor(rect.width));
      const h = Math.max(1, Math.floor(rect.height));
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      hasDrawn = false;
      if (hint) hint.classList.remove('is-hidden');
    }

    function pointerPos(e) {
      const rect = canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    }

    function setStatus(brush) {
      if (!status || !brush) return;
      const size = brush.dataset.size || '';
      const name = brush.dataset.name || '';
      status.textContent = `Pinsel ${size}${name ? ` · ${name}` : ''} · Strichstärke ${brush.dataset.width || strokeWidth}px`;
    }

    function selectBrush(brush) {
      if (!brush || brush.hidden) return;
      brushes.forEach((b) => {
        b.classList.toggle('is-active', b === brush);
        b.setAttribute('aria-pressed', b === brush ? 'true' : 'false');
      });
      strokeWidth = parseFloat(brush.dataset.width) || 2;
      setStatus(brush);
    }

    function filterSet(setKey) {
      activeSet = setKey;
      setTabs.forEach((tab) => {
        const on = tab.dataset.simSet === setKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      brushes.forEach((b) => {
        b.hidden = b.dataset.setKey !== setKey;
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      const first = brushes.find((b) => b.dataset.setKey === setKey);
      if (first) selectBrush(first);
    }

    function drawLine(x1, y1, x2, y2) {
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = strokeWidth;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }

    function startDraw(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drawing = true;
      const { x, y } = pointerPos(e);
      lastX = x;
      lastY = y;
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = strokeWidth;
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x + 0.01, y + 0.01);
      ctx.stroke();
      if (!hasDrawn) {
        hasDrawn = true;
        if (hint) hint.classList.add('is-hidden');
      }
      canvas.setPointerCapture(e.pointerId);
      e.preventDefault();
    }

    function moveDraw(e) {
      if (!drawing) return;
      const { x, y } = pointerPos(e);
      drawLine(lastX, lastY, x, y);
      lastX = x;
      lastY = y;
      e.preventDefault();
    }

    function endDraw(e) {
      if (!drawing) return;
      drawing = false;
      try {
        canvas.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    }

    function clearCanvas() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      hasDrawn = false;
      if (hint) hint.classList.remove('is-hidden');
    }

    setTabs.forEach((tab) => {
      tab.addEventListener('click', () => filterSet(tab.dataset.simSet));
    });
    brushes.forEach((brush) => {
      brush.addEventListener('click', () => selectBrush(brush));
    });
    colors.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        colors.forEach((c) => c.classList.remove('is-active'));
        swatch.classList.add('is-active');
        strokeColor = swatch.dataset.simColor || '#101820';
      });
    });
    if (clearBtn) clearBtn.addEventListener('click', clearCanvas);

    canvas.addEventListener('pointerdown', startDraw);
    canvas.addEventListener('pointermove', moveDraw);
    canvas.addEventListener('pointerup', endDraw);
    canvas.addEventListener('pointercancel', endDraw);
    canvas.addEventListener('pointerleave', endDraw);

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    filterSet('basic');
  }

  function initLucideIcons() {
    const mount = () => {
      if (!window.lucide || typeof window.lucide.createIcons !== 'function') return false;
      window.lucide.createIcons({
        attrs: {
          'stroke-width': 1.75,
          'stroke': 'currentColor',
          'fill': 'none',
        },
      });
      return true;
    };

    if (mount()) return;

    // Lucide script may still be loading (defer order)
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (mount() || tries > 40) clearInterval(timer);
    }, 50);
  }

  function initBundleAdd() {
    document.querySelectorAll('[data-painta-bundle-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.disabled) return;

        let variantIds = String(btn.dataset.variants || '')
          .split(',')
          .map((id) => Number(id.trim()))
          .filter((id) => id > 0);

        // Legacy fallback: data-variant-a / data-variant-b
        if (!variantIds.length) {
          const idA = Number(btn.dataset.variantA);
          const idB = Number(btn.dataset.variantB);
          variantIds = [idA, idB].filter((id) => id > 0);
        }

        if (variantIds.length < 2) return;

        const items = variantIds.map((id) => ({ id, quantity: 1 }));
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartType = window.themeVariables?.settings?.cartType;
          const openDrawer = cartType === 'drawer';

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, openMiniCart: openDrawer },
            })
          );

          btn.textContent =
            variantIds.length > 2 ? 'Alle hinzugefügt' : 'Beide hinzugefügt';
          if (openDrawer) {
            const toggle = document.querySelector(
              '[data-action="toggle-drawer"][data-drawer="cart"]'
            );
            if (toggle && !toggle.classList.contains('is-active')) {
              setTimeout(() => toggle.click(), 120);
            }
          }
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = original;
          }, 2200);
        } catch (err) {
          console.error('[painta] bundle add to cart', err);
          btn.disabled = false;
          btn.textContent = original;
        }
      });
    });

    document.querySelectorAll('[data-painta-copy-code]').forEach((el) => {
      el.addEventListener('click', async () => {
        const code = el.dataset.code || el.textContent.trim();
        if (!code) return;
        const original = el.textContent;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const input = document.createElement('input');
            input.value = code;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          el.textContent = 'Kopiert';
          setTimeout(() => {
            el.textContent = original;
          }, 1600);
        } catch (err) {
          console.error('[painta] copy code', err);
        }
      });
    });
  }

  function init() {
    initHeroVideos();
    document.querySelectorAll('[data-painta-parade]').forEach(initBrushParade);
    document.querySelectorAll('[data-painta-faq]').forEach(initFaq);
    document.querySelectorAll('[data-painta-sim]').forEach(initSimulator);
    initBundleAdd();
    initLucideIcons();
    initSmoothAnchors();

    // Deep link on load: #pinsel-basic / #pinsel-detail
    const hash = window.location.hash;
    if (hash === '#pinsel-basic' || hash === '#pinsel-detail') {
      goToPaintaTarget(hash, { updateHash: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
